import React, { Component } from "react";

// components
import Accordion from "../components/accordion";

// actions
import { getPageBySlug } from "../actions";

class InfoPage extends Component {
  state = {
    data: {},
    slug: null,
    id: null,
    loading: true
  };

  componentDidMount() {
    const { pathname } = this.props.location;
    getPageBySlug(pathname).then(res =>
      this.setState({
        data: res.data,
        slug: res.slug,
        id: res.id,
        loading: false
      })
    );

    window.scrollTo(0, 0);
  }

  render() {
    const { data } = this.state;
    return (
      <main id="info">
        <div className="info__content">
          <h1 className="heading heading--super orange">FAQ's</h1>
          <div className="faq-list">
            {data &&
              data.faqs &&
              data.faqs.map((q, index) => {
                return (
                  <Accordion key={index} title={q.question} index={index}>
                    <p>{q.answer}</p>
                  </Accordion>
                );
              })}
          </div>
        </div>
      </main>
    );
  }
}

export default InfoPage;



// WEBPACK FOOTER //
// ./src/containers/InfoPage.js